// Shared data layer for the /photos map — fetches once and caches the
// promise so navigating there after prefetchMapPhotos() has already run
// (e.g. from the homepage) doesn't re-trigger the request.
import { buildMockPhotos } from './world-map-mock';

function thumbUrl(src, size = 220) {
  if (!src) return '';
  if (src.includes('res.cloudinary.com')) {
    return src.replace('/upload/', `/upload/f_auto,q_auto,w_${size},h_${size},c_fill/`);
  }
  return src;
}
function fullUrl(src) {
  if (!src) return '';
  if (src.includes('res.cloudinary.com')) {
    return src.replace('/upload/', '/upload/f_auto,q_auto,w_1600/');
  }
  return src;
}
function splitLocation(loc) {
  if (!loc) return { city: 'Unknown', country: '' };
  const parts = loc.split(',');
  const city = parts[0].trim();
  const country = parts.slice(1).join(',').trim();
  return { city, country };
}

async function fetchMapPhotos() {
  try {
    const r = await fetch('/api/photos?map=1');
    if (!r.ok) throw new Error('HTTP ' + r.status);
    const json = await r.json();
    return (json.photos || []).map((p) => {
      const { city, country } = splitLocation(p.location);
      return { ...p, thumb: thumbUrl(p.src, 220), full: fullUrl(p.src), city, country };
    });
  } catch (e) {
    console.warn('[map] falling back to mock world data:', e.message);
    return buildMockPhotos();
  }
}

let cachedPromise = null;

// Returns the shared in-flight/resolved fetch, starting it on first call.
export function loadMapPhotos() {
  if (!cachedPromise) cachedPromise = fetchMapPhotos();
  return cachedPromise;
}

// Fire-and-forget — call from any page that wants to warm the cache
// before the user actually navigates to /photos.
export function prefetchMapPhotos() {
  loadMapPhotos();
}
